import { InteractionEventType, } from '@debbie/common/dist/interactions/events/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../../theme.js';
import Alert from '../../../Alert.js';
import Col from '../../../Grid/Col.js';
import Row from '../../../Grid/Row.js';
import CheckCircle from '../../../Icons/CheckCircle.js';
import Shield from '../../../Icons/Shield.js';
import XCircle from '../../../Icons/XCircle.js';
import Well from '../../../Well.js';
import { Box } from '../Helpers.js';
import CommonEvent from './CommonEvents.js';
const EmailEventCmp = (props) => {
    switch (props.event.type) {
        case InteractionEventType.Delivered:
            return React.createElement(DeliveredEvent, { event: props.event });
        case InteractionEventType.Opened:
            return React.createElement(OpenedEvent, { event: props.event });
        case InteractionEventType.Failed:
            return React.createElement(FailedEvent, { event: props.event });
        case InteractionEventType.Delayed:
            return React.createElement(DelayedEvent, { event: props.event });
        case InteractionEventType.Complained:
            return React.createElement(ComplainedEvent, { event: props.event });
        default:
            return React.createElement(CommonEvent, { event: props.event });
    }
};
const DeliveredEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Delivered) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(CheckCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Delivered]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.deliveredAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.recipientDomain, body: `${event.data.recipientDomain}${event.data.mailboxProvider ? ` (${event.data.mailboxProvider})` : ''}` })),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.recipient, body: event.data.recipientEmail }),
            React.createElement(Box, { header: lang.interactions.recipientIpAddress, body: event.data.recipientIpAddress || 'N/A' })),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.deliveryMethod, body: event.data.deliveryMethod }),
            React.createElement(Box, { header: lang.interactions.routingDomain, body: event.data.routingDomain }))));
};
const OpenedEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Opened) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } }, lang.interactionEventTypes[InteractionEventType.Opened]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.openedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: "Geo IP", body: event.data.geoIp?.zipcode && event.data.geoIp?.city ? (React.createElement(React.Fragment, null,
                    event.data.geoIp?.zipcode,
                    " ",
                    event.data.geoIp?.city,
                    ",",
                    ' ',
                    event.data.geoIp?.country)) : (React.createElement(React.Fragment, null,
                    "Long. ",
                    event.data.geoIp?.longitude,
                    ", lat.",
                    ' ',
                    event.data.geoIp?.latitude)) })),
        React.createElement(Alert, { size: "small", style: {
                marginTop: `${THEME.GRID_SPACING}px`,
            }, message: lang.interactions.emailOpenedWarning })));
};
const FailedEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Failed) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(XCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Failed]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.failedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.bounceCode, body: event.data.bounceClass || 'N/A' })),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.recipient, body: event.data.recipientEmail }),
            React.createElement(Box, { header: lang.interactions.errorCode, body: event.data.errorCode || 'N/A' })),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: {
                        fontSize: '0.9em',
                        opacity: 0.65,
                    } }, lang.interactions.reason),
                React.createElement("p", { style: { fontFamily: 'JetBrains Mono, monospace' } },
                    React.createElement("code", null, event.data.reason))))));
};
const DelayedEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Delayed) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactions.emailDelayed),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.delayedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.delayReason, body: event.data.reason }))));
};
const ComplainedEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Complained) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(XCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Complained]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.complainedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.complaintType, body: event.data.complaintType })),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.recipient, body: event.data.recipientEmail }))));
};
export default EmailEventCmp;
//# sourceMappingURL=Email.js.map